module.exports = __webpack_public_path__ + "static/media/stripe.3b889426.svg";